"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusBrowserService = void 0;
/**
 * @class
 *
 * This class makes IPC bus and RTK/JET interfaces compatible
 * It is a wrapper around RTK object in Browser's root object 'window'
 * RTK should be injected into 'window' to make this class able to work with it
 */
class BusBrowserService {
    constructor() {
        this.channelMap = new Map();
        this.bus = this.pickBrowserBus();
    }
    pickBrowserBus() {
        if ('RTK' in window)
            return window.RTK.Interop;
        return window.JET;
    }
    subscribe(channel, callback) {
        const subscription = this.bus.subscribe(channel, (data) => {
            let parsedData = data;
            if (typeof data === 'string') {
                try {
                    parsedData = JSON.parse(data);
                }
                catch (_a) {
                    /* empty */
                }
            }
            callback(channel, parsedData);
        });
        if (!this.channelMap.has(channel)) {
            this.channelMap.set(channel, new Map());
        }
        const callbackMap = this.channelMap.get(channel);
        if (callbackMap && !callbackMap.has(callback)) {
            callbackMap.set(callback, subscription);
        }
        return subscription;
    }
    unsubscribe(channel, callback) {
        const callbackMap = this.channelMap.get(channel);
        if (callbackMap) {
            const subscription = callbackMap.get(callback);
            if (subscription) {
                subscription.unsubscribe();
                callbackMap.delete(callback);
            }
        }
    }
    publish(channel, data) {
        return this.bus.publish(channel, data);
    }
    connect() {
        return Promise.resolve(void 0);
    }
}
exports.BusBrowserService = BusBrowserService;
//# sourceMappingURL=data:application/json;base64,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